<template>
    <div class="bg-white px-3 index" >
        <div class="add_tits" ref="titles">
            <el-form class="form-inlines u-f u-jsb" :inline="true">
                <div>
                    <el-form-item>
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small" @click="handleAdd">新增
                        </el-button>
                    </el-form-item>
                    <el-form-item>
                        <el-button type="primary" size="small" @click="search">搜索
                        </el-button>
                    </el-form-item>
                </div>
            </el-form>
        </div>
        <div class="ibox-content">
            <el-table :data="tableData" style="width: 100%;margin-bottom: 20px;" :height="height" row-key="id" border
                :tree-props="{children: 'child'}">
                <el-table-column prop="id" label="编号"></el-table-column>
                <el-table-column prop="modular" label="模块名称"></el-table-column>
                <el-table-column prop="regular" label="模块地址" show-overflow-tooltip></el-table-column>
                <el-table-column label="操作" width="250" align="center">
                    <template slot-scope="scope">
                        <el-button type="primary" icon="el-icon-circle-plus-outline" size="small"
                            @click="handleAdd(scope.row)">
                        </el-button>
                        <el-button size="mini" type="primary" icon="el-icon-edit-outline"
                            @click="handleEdit(scope.row,scope.$index)"></el-button>
                        <el-button size="mini" type="danger" icon="el-icon-delete"
                            @click="handleDelet(scope.row,scope.$index)"></el-button>
                    </template>
                </el-table-column>
            </el-table>

        </div>
        <el-dialog title="类别设置" :visible.sync="dialogVisible" center width="40%" class="dialogs">
            <el-divider></el-divider>
            <div class="dialog-ibox-content">
                <el-form :model="ruleForm" :rules="rule" ref="ruleForm" label-width="150px" class="demo-ruleForm">
                    <el-form-item label="模块名称" prop='modular'>
                        <el-input v-model="ruleForm.modular" size="small"></el-input>
                    </el-form-item>
                    <el-form-item label="匹配网址">
                        <el-input v-model="ruleForm.regular" size="small"> </el-input>
                    </el-form-item>
                    <el-form-item label="动态网址">
                        <el-radio-group v-model="ruleForm.is_dynamic">
                            <el-radio :label="0">否</el-radio>
                            <el-radio :label="1">是</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <div v-if="ruleForm.is_dynamic==1">
                        <el-form-item label="动态类型">
                        <el-radio-group v-model="ruleForm.dynamic_type">
                            <el-radio :label="1">数据</el-radio>
                            <el-radio :label="2">页面</el-radio>
                        </el-radio-group>
                    </el-form-item>
                        <el-form-item label="表名">
                            <el-input v-model="ruleForm.table_name" size="small"> </el-input>
                        </el-form-item>
                        <el-form-item label="字段名">
                            <el-input v-model="ruleForm.field_name" size="small"> </el-input>
                        </el-form-item>
                    </div>


                </el-form>
            </div>
            <el-divider></el-divider>
            <span slot="footer" class="dialog-footer">
                <el-button @click="submit('ruleForm')" size="small" type="primary" :loading="subloading">提 交</el-button>
                <el-button @click="dialogVisible = false" size="small">取 消</el-button>
            </span>
        </el-dialog>


    </div>
</template>


<script>
    import {
        mapState
    } from 'vuex'
    export default {
        data() {
            return {
                loading: false,
                tableData: [],
                currentPage: 1,
                pagesize: 15,
                height: null,
                // 
                eid: '0',
                dialogVisible: false,
                subloading: false,
                ruleForm: {
                    pid: 0,
                    regular: '',
                    modular: '',
                    is_dynamic: 0,
                    field_name: '',
                    table_name: '',
                    dynamic_type:1,

                },
                rule: {
                    regular: [{
                        required: true,
                        message: '请填写',
                        trigger: 'blur'
                    }],
                    modular: [{
                        required: true,
                        message: '请填写',
                        trigger: 'blur'
                    }],
                },
            };
        },
        computed: {
            ...mapState({
                user: state => state.user.user,
            })
        },
        mounted() {
            let that = this
            that.getHeight()
            that.begin()
        },
        methods: {
            getHeight() {
                let that = this
                var titles = that.$refs.titles.offsetHeight
                that.height = window.innerHeight - titles - 170 + 'px'
                window.onresize = () => {
                    var titles = that.$refs.titles.offsetHeight
                    that.height = window.innerHeight - titles - 170 + 'px'
                }
            },
            // 搜索
            begin() {
                let that = this
                that.currentPage = 1
                that.pagesize = 15
                that.search()
            },
            search() {
                let that = this
                that.tableData = []
                that.loading = true
                axios.post("/admin/Modular/getModular", {
                        type: 2
                    }, {
                        token: true
                    })
                    .then(response => {
                        that.loading = false
                        that.tableData = response.data.data
                    })
                    .catch(error => {})
            },
            IterDelateChildren(arr) {
                for (let i = 0; i < arr.length; i++) {
                    if (arr[i].child) {
                        if (arr[i].child.length) {
                            this.IterDelateChildren(arr[i].child)
                        } else {
                            delete arr[i].child
                        }
                    }
                }
                return arr
            },
            handleSizeChange(val) {
                let that = this
                that.pagesize = val;
                that.search()
            },
            handleCurrentChange(val) {
                let that = this
                that.currentPage = val;
                that.search()
            },
            handleAdd(item) {
                let that = this
                that.dialogVisible = true
                this.ruleForm.pid = item.id ? item.id : 0
                that.eid = '0'
                that.form_clear()
            },
            form_clear() {
                let that = this
                that.ruleForm.modular = ''
                that.ruleForm.regular = ''
                this.ruleForm.is_dynamic = 0
                this.ruleForm.dynamic_type = 1
                this.ruleForm.table_name = ''
                this.ruleForm.field_name = ''
            },
            submit(formName) {
                let that = this
                that.$refs[formName].validate((valid) => {
                    if (valid) {
                        that.subloading = true
                        let urls;
                        if (this.eid && this.eid != '0') {
                            urls = "/admin/pc/Modular/update"
                        } else {
                            urls = "/admin/pc/Modular/add"
                        }
                        axios.post(urls, {
                                id: that.eid,
                                ...this.ruleForm
                            }, {
                                token: true
                            })
                            .then(response => {
                                that.subloading = false
                                if (response.data.code == '200') {
                                    that.dialogVisible = false
                                    that.search()
                                } else {
                                    that.$message.error(response.data.msg);
                                }
                            })
                            .catch(error => {
                                that.subloading = false
                            })
                    } else {
                        return false;
                    }
                });
            },
            // 编辑
            handleEdit(row, index) {
                let that = this
                that.form_clear()
                that.dialogVisible = true
                that.eid = row.id
                axios
                    .post("/admin/pc/Modular/read", {
                        id: that.eid,
                    }, {
                        token: true
                    })
                    .then(res => {
                        this.ruleForm.pid = res.data.data.pid
                        this.ruleForm.modular = res.data.data.modular
                        this.ruleForm.regular = res.data.data.regular
                        this.ruleForm.is_dynamic = res.data.data.is_dynamic
                        this.ruleForm.table_name = res.data.data.table_name
                        this.ruleForm.field_name = res.data.data.field_name
                        this.ruleForm.dynamic_type = res.data.data.dynamic_type
                    })
                    .catch(error => {})
            },
            // 删除
            handleDelet(row, index) {
                let that = this
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    axios
                        .post("/admin/pc/Modular/del", {
                            id: row.id,
                        }, {
                            token: true
                        })
                        .then(response => {
                            if (response.data.code == '200') {
                                this.$message({
                                    type: 'success',
                                    message: '删除成功!'
                                });
                                that.search()
                            } else {
                                that.$message.error(response.data.msg);
                            }
                        })
                        .catch(error => {})
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                });
            },

        },
        watch: {
            'ruleForm.is_dynamic'(nval, oval) {
                if (nval == 0) {
                    this.ruleForm.table_name = ''
                    this.ruleForm.field_name = ''
                }
            }
        }
    };
</script>


<style scoped>
</style>